import React from "react"; 
import { Link } from "react-router-dom";    
import CreateRegionForm from "./CreateRegionForm";

const CreateRegion = () => {
  return (
    <>
      {/* Breadcrumb */}
      {/* <div className="breadcrumb-card">
        <h5>Create Regions</h5>

        <ul className="breadcrumb">
          <li>
            <Link to="/dashboard/ecommerce/">
              <i className="material-symbols-outlined">home</i>
              Dashboard
            </Link>
          </li>
          <li>eCommerce</li>
          <li>Create Region</li>
        </ul>
      </div> */}

      <CreateRegionForm />
    </>
  );
};

export default CreateRegion;
